// Generated by TsRpcGenerator, do not modify manually
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols, ES6UnusedImports

import { Observable } from "rxjs"
import { InitializedChannel } from "../api-types.ts"
import type { AppDate, AppDateTime, Nominal, Pair, Ref } from "../api-types.ts"
import { getInitial, getResult, getUpdates } from "../types.ts"

import { ApiService } from "../ApiService.ts"

import { AvailableLog, DevEnvPreviewMeta, FileContentIn, ProjectKey, SshKeyReportData, TID, UPreviewProcessesApiState, WarmupSnapshot } from "./TypeDefinitions.ts"

export interface PreviewApi {
  canSshToPreviewEnv(previewId: TID | null, previewV2EnvId: TID | null): Promise<Observable<boolean>>

  createProjectWarmupSnapshot(projectKey: ProjectKey, repositoryName: string): Promise<WarmupSnapshot>

  deleteProjectWarmupSnapshot(projectKey: ProjectKey, repositoryName: string, warmupSnapshotId: TID): Promise<void>

  getActivePooledPreviewId(projectKey: ProjectKey, repositoryName: string): Promise<TID | null>

  getPreviewMeta(subdomain: string): Promise<DevEnvPreviewMeta>

  getSshConnectCommandForPreview(previewId: TID | null, previewV2EnvId: TID | null): Promise<string>

  getSshTunnelCommandForPreview(previewId: TID | null, previewV2Id: TID | null): Promise<string>

  hasPermission(subdomain: string): Promise<boolean>

  listProjectWarmupSnapshots(projectKey: ProjectKey, repositoryName: string): Promise<WarmupSnapshot[]>

  putFilesToPreviewEnv(previewId: TID | null, previewV2EnvId: TID | null, files: FileContentIn[]): Promise<void>

  putUserKeysIntoPreviewEnv(previewId: TID | null, previewV2EnvId: TID | null): Promise<SshKeyReportData[]>

  restartPreview(subdomain: string): Promise<void>

  subscribeToPreviewAppLogs(previewId: TID | null, previewV2EnvId: TID | null, logId: string): Promise<Observable<string>>

  subscribeToPreviewLogList(previewId: TID | null, previewV2Id: TID | null): Promise<Observable<AvailableLog[]>>

  subscribeToPreviewProcessState(previewId: TID | null, previewV2Id: TID | null): Promise<Observable<UPreviewProcessesApiState>>

  subscribeToPreviewReadyEstimate(previewId: TID): Promise<Observable<number>>
}

export class PreviewApiClient implements PreviewApi {
  constructor(private service: ApiService) {}

  async canSshToPreviewEnv(previewId: TID | null, previewV2EnvId: TID | null): Promise<Observable<boolean>> {
    return getUpdates(await this.service.rpc<void, boolean>("flux/PreviewApi/canSshToPreviewEnv", {
      previewId: previewId,
      previewV2EnvId: previewV2EnvId,
    }))
  }

  async createProjectWarmupSnapshot(projectKey: ProjectKey, repositoryName: string): Promise<WarmupSnapshot> {
    return getResult(await this.service.rpc<WarmupSnapshot, never>("PreviewApi/createProjectWarmupSnapshot", {
      projectKey: projectKey,
      repositoryName: repositoryName,
    }))
  }

  async deleteProjectWarmupSnapshot(projectKey: ProjectKey, repositoryName: string, warmupSnapshotId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("PreviewApi/deleteProjectWarmupSnapshot", {
      projectKey: projectKey,
      repositoryName: repositoryName,
      warmupSnapshotId: warmupSnapshotId,
    }))
  }

  async getActivePooledPreviewId(projectKey: ProjectKey, repositoryName: string): Promise<TID | null> {
    return getResult(await this.service.rpc<TID | null, never>("PreviewApi/getActivePooledPreviewId", {
      projectKey: projectKey,
      repositoryName: repositoryName,
    }))
  }

  async getPreviewMeta(subdomain: string): Promise<DevEnvPreviewMeta> {
    return getResult(await this.service.rpc<DevEnvPreviewMeta, never>("PreviewApi/getPreviewMeta", {
      subdomain: subdomain,
    }))
  }

  async getSshConnectCommandForPreview(previewId: TID | null, previewV2EnvId: TID | null): Promise<string> {
    return getResult(await this.service.rpc<string, never>("PreviewApi/getSshConnectCommandForPreview", {
      previewId: previewId,
      previewV2EnvId: previewV2EnvId,
    }))
  }

  async getSshTunnelCommandForPreview(previewId: TID | null, previewV2Id: TID | null): Promise<string> {
    return getResult(await this.service.rpc<string, never>("PreviewApi/getSshTunnelCommandForPreview", {
      previewId: previewId,
      previewV2Id: previewV2Id,
    }))
  }

  async hasPermission(subdomain: string): Promise<boolean> {
    return getResult(await this.service.rpc<boolean, never>("PreviewApi/hasPermission", {
      subdomain: subdomain,
    }))
  }

  async listProjectWarmupSnapshots(projectKey: ProjectKey, repositoryName: string): Promise<WarmupSnapshot[]> {
    return getResult(await this.service.rpc<WarmupSnapshot[], never>("PreviewApi/listProjectWarmupSnapshots", {
      projectKey: projectKey,
      repositoryName: repositoryName,
    }))
  }

  async putFilesToPreviewEnv(previewId: TID | null, previewV2EnvId: TID | null, files: FileContentIn[]): Promise<void> {
    return getResult(await this.service.rpc<void, never>("PreviewApi/putFilesToPreviewEnv", {
      previewId: previewId,
      previewV2EnvId: previewV2EnvId,
      files: files,
    }))
  }

  async putUserKeysIntoPreviewEnv(previewId: TID | null, previewV2EnvId: TID | null): Promise<SshKeyReportData[]> {
    return getResult(await this.service.rpc<SshKeyReportData[], never>("PreviewApi/putUserKeysIntoPreviewEnv", {
      previewId: previewId,
      previewV2EnvId: previewV2EnvId,
    }))
  }

  async restartPreview(subdomain: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("PreviewApi/restartPreview", {
      subdomain: subdomain,
    }))
  }

  async subscribeToPreviewAppLogs(previewId: TID | null, previewV2EnvId: TID | null, logId: string): Promise<Observable<string>> {
    return getUpdates(await this.service.rpc<void, string>("flux/PreviewApi/subscribeToPreviewAppLogs", {
      previewId: previewId,
      previewV2EnvId: previewV2EnvId,
      logId: logId,
    }))
  }

  async subscribeToPreviewLogList(previewId: TID | null, previewV2Id: TID | null): Promise<Observable<AvailableLog[]>> {
    return getUpdates(await this.service.rpc<void, AvailableLog[]>("flux/PreviewApi/subscribeToPreviewLogList", {
      previewId: previewId,
      previewV2Id: previewV2Id,
    }))
  }

  async subscribeToPreviewProcessState(previewId: TID | null, previewV2Id: TID | null): Promise<Observable<UPreviewProcessesApiState>> {
    return getUpdates(await this.service.rpc<void, UPreviewProcessesApiState>("flux/PreviewApi/subscribeToPreviewProcessState", {
      previewId: previewId,
      previewV2Id: previewV2Id,
    }))
  }

  async subscribeToPreviewReadyEstimate(previewId: TID): Promise<Observable<number>> {
    return getUpdates(await this.service.rpc<void, number>("flux/PreviewApi/subscribeToPreviewReadyEstimate", {
      previewId: previewId,
    }))
  }

}

